intra_module.directive('studentContact', () => ({
    restrict:    'E',
    templateUrl: 'directives/student_contact/template.html',
    controller:  'StudentContactCtrl',
    replace:     true,
    scope: {
        contactid: '@',
        heading: '@',
    }
}));

intra_module.controller('StudentContactCtrl', function($scope, ngNotify, api_url) {
	$scope.contact = {};
	$scope.errors = {};
	$scope.error = null;

	// TODO: when PR#406 has been merged, this should be replaced by injecting hub_api_url in this controller.
	const hub_api_url = api_url.replace("//intra-api.", "//api.");
	const contact_url = `${hub_api_url}/intra/my-student-infos/${$scope.contactid}`;
	const modal_selector = `#modal-${$scope.contactid}`;
	const form_selector = modal_selector + " form";
	
	function fetchContact() {
		fetch(contact_url, { credentials: "include"})
			.then( (response) => {
				if (!response.ok) {
					throw new Error("Erreur lors de la récupération des informations de l'étudiant.");
				}
				return response.json();
			})
			.then( (js) => {
				$scope.contact = js;
				$scope.$apply();
			}).catch( (err) => {
				ngNotify.set('Erreur lors de la récupération des informations administratives.', 'error');
				console.log('failed to fetch student infos:', err);
			});
	}

	function commitContact() {
		const body = {};
		for (const key in $scope.edit) {
			body[key] = $scope.edit[key];
		}
		fetch(contact_url, {
			method: "PUT",
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body),
			credentials: "include",
		}).then( (response) => {
			if (!response.ok) {
				throw new Error("invalid server response status");
			} else {
				endEdit();
			}
		}).catch( (err) => {
			$scope.error = "Une erreur est survenue lors de la sauvegarde. Veuillez réessayer";
			$scope.$apply();
			console.log('failed to commit contact:', $scope.contactid, err);
		});
	}

	
	function errorIfEmpty(field, errors) {
		const value = $scope.edit[field];
		if (value == "" || value === undefined || value === null) {
			errors.set(field, 'Ce champs doit être renseigné.');
		}
	}
	
	$scope.startEdit = function() {
		$scope.edit = angular.copy($scope.contact);
		$(modal_selector).modal({ show: true });
	};

	function endEdit() {
		ngNotify.set('Contact enregisté.', 'success');
		$(modal_selector).modal('hide');
		fetchContact();
	};

	$scope.save = function() {
		const errors = new Map();
		$scope.error = null;
		$scope.errors = {};
		errorIfEmpty('salutation', errors);
		errorIfEmpty('firstname', errors);
		errorIfEmpty('lastname', errors);
		errorIfEmpty('address1', errors);
		errorIfEmpty('zip_code', errors);
		errorIfEmpty('city', errors);
		if (!$scope.edit.tel && !$scope.edit.mobile) {
			errors.set('mobile', "Veuillez renseigner au moins un numéro de téléphone.");
		}
		errorIfEmpty('mail', errors);
		if (errors.size) {
			// if there are any errors, copy into scope (to notify user) and abort submission.
			for (const [key, message] of errors.entries()) {
				$scope.errors[key] = message;
			}
		} else {
			commitContact();
		}		
	};
	
	fetchContact();
});
